import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'

interface PosMenu {
  id: number
  name: string
  description: string
  version: string
  storeId: string
  tier: string
  type: string
  createdAt: string
  createdBy: number
  updatedAt: number | null
  updatedBy: number | null
}

interface PosMenuInitialState {
  posMenus?: PosMenu[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: PosMenuInitialState = {
  posMenus: null,
  loading: false,
  success: null,
  error: null
}

interface PosMenuConfigurationResponse {
  data: PosMenu[]
}

export const getPosMenus = createAsyncThunk<PosMenuConfigurationResponse, GygQueryOptions, Redux>(
  'gygPosMenu/getAllPosMenus',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`pos-menu`, { params: gygQueryOptions })

    return responseData
  }
)

const gygPosMenuSlice = createSlice({
  name: 'getPosMenu',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPosMenus.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getPosMenus.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.posMenus = action.payload.data
      })
      .addCase(getPosMenus.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch pos menus'
      })
  }
})

export default gygPosMenuSlice.reducer
